<template>
  <div class="games">
    <span id="g-add-up">
      <GamesAddUpdate
        v-if="showAdd"
        @showAdd="close"
        @showMore="showMore"
        :page="page"
        :week="week"
        :titleCard="titleCard"
        :updateData="updateData"
      />
      <GamesResultsAddUpdate
        v-if="showResult"
        @showAdd="closeResult"
        @showMore="showMore"
        :page="page"
        :updateData="resultData"
      />
    </span>
    <va-card :title="$t('games.cards.title') + ' '+ this.week">
      <template slot="actions">
        <va-button
          @click="open"
          icon="fa fa-plus"
          href="#g-add-up"
        />
      </template>
      <va-data-table
        :fields="fields"
        :data="games"
        :per-page="perPage"
        :totalPages="totalPages"
        :loading="loading"
        @page-selected="showMore"
        no-data-label="Sem Dados Cadastrados"
        api-mode
      >
        <template slot="actions" slot-scope="props">
          <va-popover :message="`${$t('games.tooltips.result')}`" placement="bottom">
            <va-button
              flat
              color="gray"
              icon="fa fa-futbol-o"
              href="#g-add-up"
              @click="resultOpen(props.rowData)"
            />
          </va-popover>
          <va-popover :message="`${$t('games.tooltips.update')}`" placement="bottom">
            <va-button
              flat
              color="gray"
              icon="fa fa-pencil"
              @click="update(props.rowData)"
              href="#g-add-up"
            />
          </va-popover>
          <va-popover :message="`${$t('games.tooltips.deleteGame')}`" placement="bottom">
            <va-button
              flat
              color="gray"
              icon="fa fa-trash"
              @click="showModal(props.rowData)"
            />
          </va-popover>
          <va-popover v-if="props.rowData.results.length > 0" :message="`${$t('games.tooltips.deleteResult')}`" placement="bottom">
            <va-button
              flat
              color="gray"
              icon="fa fa-trash-o"
              @click="showModalResult(props.rowData.results[0])"
            />
          </va-popover>
        </template>
      </va-data-table>
    </va-card>
    <va-modal
      v-model="modalDeletar"
      size="small"
      :title="$t('modals.titleDelete')"
      :message="$t('games.modals.message')"
      :okText="$t('modals.confirm') "
      :cancelText="$t('modals.cancel')"
      @ok="deleting"
    />
    <va-modal
      v-model="modalDeletarResult"
      size="small"
      :title="$t('modals.titleDelete')"
      :message="$t('games.modals.result-message')"
      :okText="$t('modals.confirm') "
      :cancelText="$t('modals.cancel')"
      @ok="deletingResult"
    />
  </div>
</template>

<script>
import gql from 'graphql-tag'
import GamesAddUpdate from './GamesAddUpdate'
import GamesResultsAddUpdate from './GamesResultsAddUpdate'

const perPage = 30
export default {
  name: 'games',
  components: {
    GamesAddUpdate,
    GamesResultsAddUpdate,
  },
  props: {
    week: {
      required: true,
    },
  },
  methods: {
    close (v) {
      this.showAdd = v
      this.updateData = null
    },
    closeResult (v) {
      this.showResult = v
      this.resultData = null
    },
    resultOpen (data) {
      this.resultData = data
      this.showResult = true
    },
    update (data) {
      this.titleCard = 'update'
      this.updateData = data
      this.showAdd = true
    },
    open () {
      this.updateData = null
      this.showAdd = true
      this.titleCard = 'create'
    },
    showModal (data) {
      this.modalDeletar = true
      this.deleteId = data
    },
    showModalResult (data) {
      this.modalDeletarResult = true
      this.deleteId = data
    },
    showMore (page) {
      this.loading = true
      this.page = page
      this.$apollo.queries.games.fetchMore({
        variables: {
          page: (page - 1) * this.perPage,
          perPage: this.perPage,
        },
        updateQuery: (_, { fetchMoreResult }) => {
          this.loading = false
          return fetchMoreResult
        },
      })
    },
    deleting () {
      this.$apollo
        .mutate({
          mutation: gql`
            mutation MyMutation($id: Int!) {
              delete_game_by_pk(id: $id) {
                id
              }
            }
          `,
          variables: {
            id: this.deleteId.id,
          },
        })
        .then(data => {
          this.$apollo.queries.pages.refetch()
          this.showMore(this.page)
          this.showToast(
            this.$t('toasts.successDelete'),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
        .catch(_ => {
          this.showToast(
            this.$t('toasts.errorDelete'),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
    },
    deletingResult () {
      this.$apollo
        .mutate({
          mutation: gql`
            mutation MyMutation($id: Int!) {
              delete_result_by_pk(id: $id) {
                id
              }
            }
          `,
          variables: {
            id: this.deleteId.id,
          },
        })
        .then(data => {
          this.$apollo.queries.pages.refetch()
          this.showMore(this.page)
          this.showToast(
            this.$t('toasts.successDelete'),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
        .catch(_ => {
          this.showToast(
            this.$t('toasts.errorDelete'),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
    },
  },
  data () {
    return {
      games: [],
      page: 1,
      perPage: perPage,
      pages: null,
      loading: false,
      showAdd: false,
      showResult: false,
      modalDeletar: false,
      modalDeletarResult: false,
      deleteId: 0,
      titleCard: '',
      updateData: null,
      resultData: null,
      userId: null,
    }
  },
  apollo: {
    games: {
      query: gql`
      query MyQuery($page: Int, $perPage: Int, $week: Int) {
        games: game(limit: $perPage, offset: $page, where: {week_id: {_eq: $week}}, order_by: {datetime: asc}) {
          id
          club1 {
            id
            name
          }
          club2 {
            id
            name
          }
          championship {
            id
            name
          }
          week {
            id
            name
          }
          datetime
          datetime_fuso
          results {
            id
            pts_club1
            pts_club2
          }
        }
      }
      `,
      variables () {
        return {
          perPage,
          page: 0,
          week: this.week,
        }
      },
    },
    pages: {
      query: gql`
      query MyQuery($week: Int) {
        pages: game_aggregate(where: {week_id: {_eq: $week}}) {
          aggregate {
            count
          }
        }
      }
      `,
      variables () {
        return {
          week: this.week,
        }
      },
    },
  },
  computed: {
    totalPages () {
      return this.pages != null ? Math.ceil(this.pages.aggregate.count / this.perPage) : 0
    },
    fields () {
      const moment = this.$moment
      return [{
        name: 'id',
        title: this.$t('tables.id'),
        width: '50px',
      }, {
        name: 'club1',
        title: this.$t('games.headings.club1'),
        width: '15%',
        callback (value) {
          return value.name
        },
      }, {
        name: 'club2',
        title: this.$t('games.headings.club2'),
        width: '15%',
        callback (value) {
          return value.name
        },
      }, {
        name: 'championship',
        title: this.$t('games.headings.championship'),
        width: '10%',
        callback (value) {
          return value.name
        },
      }, {
        name: 'week',
        title: this.$t('games.headings.week'),
        width: '10%',
        callback (value) {
          return value.name
        },
      }, {
        name: 'datetime_fuso',
        title: this.$t('games.headings.datetime'),
        callback (value) {
          return moment(value).format('DD/MM/YYYY [as] HH:mm:ss')
        },
      }, {
        name: 'results',
        title: this.$t('games.headings.result'),
        width: '10%',
        titleClass: 'text-center',
        dataClass: 'text-center',
        callback (value) {
          return value.length > 0 ? value[0].pts_club1 + ' X ' + value[0].pts_club2 : 'X'
        },
      }, {
        name: '__slot:actions',
        title: this.$t('tables.actions'),
        titleClass: 'text-center',
        dataClass: 'text-center',
      }]
    },
  },
  mounted () {
    if (Object.keys(this.$apollo.queries).includes('games')) {
      this.$apollo.queries.pages.refetch()
      this.$apollo.queries.games.refetch()
    }
  },
}
</script>

<style lang="scss">
</style>
